import {
    getDate,
    getMonth,
    getYear,
    isBefore,
    isValid,
    startOfDay,
} from 'date-fns';

export function getYearSlice(str: string) {
  return str.substring(0, 4);
}

export function getMonthSlice(str: string) {
  return str.substring(4, 6);
}

export function getDaySlice(str: string) {
  return str.substring(6, 8);
}

// parse string like '20140101' to Date object
export function parseToDate(str: string): Date | undefined {
  const year = parseInt(getYearSlice(str));
  const month = parseInt(getMonthSlice(str));
  const day = parseInt(getDaySlice(str));
  if (!(1 <= month && month <= 12)) {
    return;
  } else if (!(1 <= day && day <= 31)) {
    return;
  }
  const date = new Date(year, month - 1, day);
  if (
        getDate(date) !== day ||
        getMonth(date) !== month - 1 ||
        getYear(date) !== year
    ) {
    return;
  }
  return date;
}

export function isValidBirthdate(date: Date) {
  return (
        isValid(date) &&
        !isBefore(date, new Date(1900, 1, 1)) &&
        isBefore(startOfDay(date), new Date())
  );
}

const DayMap: { [key: string]: string } = {
  '01': '31',
  '02': '28',
  '03': '31',
  '04': '30',
  '05': '31',
  '06': '30',
  '07': '31',
  '08': '31',
  '09': '30',
  '10': '31',
  '11': '30',
  '12': '31',
};

export const setDayLimitFromMonth = (month: string) => {
  return DayMap[month];
};
